import type {
  AnyOfFilter,
  BoolFilter,
  CompositeFilter,
  DateFilter,
  JoinOperator,
  NumberFilter,
  QueryFilter,
  TextFilter,
  TimestampFilter,
} from './QueryRequest'

const text = (value: string) => ({
  equals: (): TextFilter => ({ filterType: 'string', value, operator: 'Equals' }),
  notEqual: (): TextFilter => ({ filterType: 'string', value, operator: 'NotEqual' }),
  contains: (): TextFilter => ({ filterType: 'string', value, operator: 'Contains' }),
  notContains: (): TextFilter => ({ filterType: 'string', value, operator: 'NotContains' }),
  startsWith: (): TextFilter => ({ filterType: 'string', value, operator: 'StartsWith' }),
  endsWith: (): TextFilter => ({ filterType: 'string', value, operator: 'EndsWith' }),
  blank: (): TextFilter => ({ filterType: 'string', value: '', operator: 'Blank' }),
  notBlank: (): TextFilter => ({ filterType: 'string', value: '', operator: 'NotBlank' }),
  greaterThan: (): TextFilter => ({ filterType: 'string', value, operator: 'GreaterThan' }),
  greaterThanOrEqualTo: (): TextFilter => ({ filterType: 'string', value, operator: 'GreaterThanOrEqualTo' }),
  lessThan: (): TextFilter => ({ filterType: 'string', value, operator: 'LessThan' }),
  lessThanOrEqualTo: (): TextFilter => ({ filterType: 'string', value, operator: 'LessThanOrEqualTo' }),
})

const number = (value: number) => ({
  equals: (): NumberFilter => ({ filterType: 'number', value, operator: 'Equals' }),
  notEqual: (): NumberFilter => ({ filterType: 'number', value, operator: 'NotEqual' }),
  lessThan: (): NumberFilter => ({ filterType: 'number', value, operator: 'LessThan' }),
  lessThanOrEqualTo: (): NumberFilter => ({ filterType: 'number', value, operator: 'LessThanOrEqualTo' }),
  greaterThan: (): NumberFilter => ({ filterType: 'number', value, operator: 'GreaterThan' }),
  greaterThanOrEqualTo: (): NumberFilter => ({ filterType: 'number', value, operator: 'GreaterThanOrEqualTo' }),
})

const date = (value: string) => ({
  equals: (): DateFilter => ({ filterType: 'date', value, operator: 'Equals' }),
  notEqual: (): DateFilter => ({ filterType: 'date', value, operator: 'NotEqual' }),
  before: (): DateFilter => ({ filterType: 'date', value, operator: 'LessThan' }),
  onOrBefore: (): DateFilter => ({ filterType: 'date', value, operator: 'LessThanOrEqualTo' }),
  after: (): DateFilter => ({ filterType: 'date', value, operator: 'GreaterThan' }),
  onOrAfter: (): DateFilter => ({ filterType: 'date', value, operator: 'GreaterThanOrEqualTo' }),
})

const timestamp = (value: string) => ({
  equals: (): TimestampFilter => ({ filterType: 'timestamp', value, operator: 'Equals' }),
  notEqual: (): TimestampFilter => ({ filterType: 'timestamp', value, operator: 'NotEqual' }),
  before: (): TimestampFilter => ({ filterType: 'timestamp', value, operator: 'LessThan' }),
  onOrBefore: (): TimestampFilter => ({ filterType: 'timestamp', value, operator: 'LessThanOrEqualTo' }),
  after: (): TimestampFilter => ({ filterType: 'timestamp', value, operator: 'GreaterThan' }),
  onOrAfter: (): TimestampFilter => ({ filterType: 'timestamp', value, operator: 'GreaterThanOrEqualTo' }),
})

const bool = (value: boolean): BoolFilter => ({ filterType: 'boolean', value })

const anyOf = (values: string[]): AnyOfFilter => ({ filterType: 'set', values })

const composite = (operator: JoinOperator, conditions: QueryFilter[]): CompositeFilter => ({
  filterType: 'composite',
  operator,
  conditions,
})

const and = (conditions: QueryFilter[]): CompositeFilter => composite('And', conditions)
const or = (conditions: QueryFilter[]): CompositeFilter => composite('Or', conditions)

export const Filters = { text, number, date, timestamp, bool, anyOf, composite, and, or }
